(() => {
  'use strict';
  document.querySelectorAll('[data-upgrade-estimate]:not([data-ready])').forEach(banner => {
    banner.dataset.ready = 'true';
    const kind = banner.dataset.kind;
    const code = new URLSearchParams(location.search).get('discount') || banner.dataset.customerCode || '';
    const match = code.match(kind === 'vip' ? /^VIP-CREDIT-([1-9]\d{0,2})-[A-Z0-9]{4}$/ : /^SK-UPGRADE-([1-9]\d?)-[A-Z0-9]{4}$/);
    if (!match) return;
    const credit = Number(match[1]);
    if (kind === 'vip' ? credit < 25 || credit > 375 || credit % 25 !== 0 : credit > 86) return;
    const base = Number(banner.dataset.baseCents);
    // Existing upgrade codes are denominated in USD. Do not subtract them from another presentment currency.
    if (banner.dataset.currency !== 'USD' || !Number.isFinite(base) || base <= credit * 100) return;
    const money = cents => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
    const message = document.createElement('span');
    message.textContent = `Estimated upgrade price: ${money(base - credit * 100)} with ${money(credit * 100)} credit. Code eligibility and your final total are confirmed at checkout. `;
    const link = document.createElement('a');
    const root = window.Shopify?.routes?.root || '/';
    if (!/^\d+$/.test(banner.dataset.variantId || '')) return;
    link.href = `${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(root + 'cart/' + banner.dataset.variantId + ':1')}`;
    link.textContent = 'Continue with this code';
    banner.append(message, link);
    banner.hidden = false;
    document.querySelector('main')?.prepend(banner);
  });
})();
